/** 供方权限 */
export enum SupplyPermission {
  /** <-----------质检报告------------> */
  /** 质检报告查看 */
  QualityInspectionReportView = 'supplier:quality-inspection-report:view-reports',
  /** 质检报告上传 */
  QualityInspectionReportPublish = 'supplier:quality-inspection-report:upload-reports',
  /** 质检报告编辑 */
  QualityInspectionReportEdit = 'supplier:quality-inspection-report:edit-reports',
  /** 质检报告删除 */
  QualityInspectionReportDelete = 'supplier:quality-inspection-report:delete-reports',
  /** 质检报告合并规则设置 */
  QualityInspectionReportMergeRules = 'supplier:report-product-merge-rules:update',
  /** <-----------非监管商品------------> */
  /** 查看非监管商品 */
  SupplyUnsuperviseCommodityView = 'supplier:non-monitored-commodity-list:view-commodities',
  /** 新建非监管商品 */
  SupplyUnsuperviseCommodityNew = 'supplier:non-monitored-commodity-list:create-commodities',
  /** 编辑非监管商品 */
  SupplyUnsuperviseCommodityEdit = 'supplier:non-monitored-commodity-list:edit-commodities',
  /** 启用非监管商品 */
  SupplyUnsuperviseCommodityEnable = 'supplier:non-monitored-commodity-list:enable-commodities',
  /** 禁用非监管商品 */
  SupplyUnsuperviseCommodityDisEnable = 'supplier:non-monitored-commodity-list:disable-commodities',
  /** 禁用非监管商品 */
  SupplyUnsuperviseCommodityDelect = 'supplier:non-monitored-commodity-list:delete-commodities',
  /** 批量导入非监管商品 */
  SupplyUnsuperviseCommodityBatchImport = 'supplier:non-monitored-commodity-list:batch-import',
  /** 批量导入非监管商品 */
  SupplyUnsuperviseCommodityBatchExport = 'supplier:non-monitored-commodity-list:batch-export',
  /** 批量启用非监管商品 */
  SupplyUnsuperviseCommodityBatchEnable = 'supplier:non-monitored-commodity-list:batch-enable',
  /** 批量禁用非监管商品 */
  SupplyUnsuperviseCommodityBatchDisEnable = 'supplier:non-monitored-commodity-list:batch-disable',
  /** 批量删除非监管商品 */
  SupplyUnsuperviseCommodityBatchDelect = 'supplier:non-monitored-commodity-list:batch-delete',
  /** 批量编辑非监管商品 */
  SupplyUnsuperviseCommodityBatchEdit = 'supplier:non-monitored-commodity-list:batch-update-info',
  /** <-----------采购合同------------> */
  /** 查看采购合同 */
  PurchaseContractView = 'supplier:purchase-contract-list:view-purchase-contracts',
  /** 采购合同创建 */
  SupplyPurchaseContractCreate = 'supplier:purchase-contract-list:create-purchase-contracts',
  /** 采购合同编辑 */
  SupplyPurchaseContractEdit = 'supplier:purchase-contract-list:edit-purchase-contracts',
  /** 采购合同删除 */
  SupplyPurchaseContractDelect = 'supplier:purchase-contract-list:delete-purchase-contracts',
  /** 采购合同发布 */
  SupplyPurchaseContractPublish = 'supplier:purchase-contract-list:publish-purchase-contracts',
  /** 采购合同关闭 */
  SupplyPurchaseContractClose = 'supplier:purchase-contract-list:close-purchase-contracts',
  /** 采购合同导入报价商品 */
  SupplyPurchaseContractImportQuotedProducts = 'supplier:purchase-contract-list:import-quoted-commodities',
  /** 采购合同导出 */
  SupplyPurchaseContractExport = 'supplier:purchase-contract-list:export-purchase-contracts',
  /** 采购合同复制 */
  SupplyPurchaseContractCopy = 'supplier:purchase-contract-list:copy-purchase-contracts',
  /** 采购合同批量发布 */
  SupplyPurchaseContractBatchPublish = 'supplier:purchase-contract-list:batch-publish',
  /** 采购合同批量导出 */
  SupplyPurchaseContractBatchExport = 'supplier:purchase-contract-list:batch-export',
  /** 采购合同批量删除 */
  SupplyPurchaseContractBatchDelect = 'supplier:purchase-contract-list:batch-delete',
  /** 采购合同批量关闭 */
  SupplyPurchaseContractBatchClose = 'supplier:purchase-contract-list:batch-close',
  /** 采购合同批量改价 */
  SupplyPurchaseContractBatchChangePrice = 'supplier:purchase-contract-list:batch-change-price',
  /** <-----------询价单------------> */
  /** 询价单查看 */
  InquiryView = 'supplier:inquiry-list:view-inquiry-order-detail',
  /** 询价单报价 */
  InquirySheetOffer = 'supplier:inquiry-list:quote',
  /** 询价单报价查看 */
  InquirySheetOfferView = 'supplier:inquiry-list:view-quotes',
  /** 询价单合同查看 */
  InquirySheetContractView = 'supplier:inquiry-list:view-contracts',
  /** <-----------报价单------------> */
  /** 报价单查看 */
  OfferOrderView = 'supplier:quotation-management:view-quotation-orders',
  /** 报价单新建 */
  OfferOrderNew = 'supplier:quotation-management:create-quotation-orders',
  /** 报价单编辑 */
  OfferOrderEdit = 'supplier:quotation-management:edit-quotation-orders',
  /** 报价单复制 */
  OfferOrderCopy = 'supplier:quotation-management:copy-quotation-orders',
  /** 报价单删除 */
  OfferOrderDelete = 'supplier:quotation-management:delete-quotation-orders',
  /**  ================================ '价格监控 ================================ '*/
  /** 批量导出 */
  MonitorBatchExport = 'supplier:price-monitoring:batch-export',
  /** <-----------采购单------------> */
  /** 采购单查看 */
  PurchaseOrderView = 'supplier:purchase-order-management:view-purchase-orders',
  /** 采购单编辑 */
  PurchaseOrderEdit = 'supplier:purchase-order-management:edit-purchase-orders',
  /** 采购单质检报告查看 */
  PurchaseOrderQualityInspectionReportView = 'supplier:purchase-order-management:view-quality-inspection-reports',
  /** 采购单收货记录查看 */
  PurchaseOrderReceiptRecordView = 'supplier:purchase-order-management:view-receipt-records',
  /** 采购单备货 */
  PurchaseOrderStockUp = 'supplier:purchase-order-management:prepare-purchase-orders',
  /** 采购单发货 */
  PurchaseOrderDeliverGoods = 'supplier:purchase-order-management:ship-purchase-orders',
  /** 采购单撤回 */
  PurchaseOrderWithdraw = 'supplier:purchase-order-management:recall-purchase-orders',
  /** 采购单打印 */
  PurchaseOrderPrint = 'supplier:purchase-order-management:print-purchase-orders',
  /** 采购单批量打印 */
  PurchaseOrderBatchPrint = 'supplier:purchase-order-management:batch-print',
  /** 采购单批量备货 */
  PurchaseOrderBatchStockUp = 'supplier:purchase-order-management:batch-prepare',
  /** 采购单批量发货 */
  PurchaseOrderBatchDeliverGoods = 'supplier:purchase-order-management:batch-ship',
  /** 采购单批量导出 */
  PurchaseOrderBatchExport = 'supplier:purchase-order-management:batch-export',
  /** 采购单批量改价 */
  PurchaseOrderBatchModifyPrice = 'supplier:purchase-order-management:bulk-repricing',
  /** 维护分拣记录 */
  PurchaseOrderUpdateSortingRecord = 'supplier:purchase-order-management:maintain-sorting-records',
  /**  ================================ '入库单管理 ================================ '*/
  /** 查看入库单 */
  InboundView = 'supplier:warehouse-inward-order-management:view-inward-orders',
  /** 编辑入库单 */
  InboundEdit = 'supplier:warehouse-inward-order-management:edit-inward-orders',
  /** 提交入库单 */
  InboundSubmit = 'supplier:warehouse-inward-order-management:submit-inward-orders',
  /** 关闭入库单 */
  InboundClose = 'supplier:warehouse-inward-order-management:close-inward-orders',
  /** 删除入库单 */
  InboundDelete = 'supplier:warehouse-inward-order-management:delete-inward-orders',
  /** 批量导出 */
  InboundExport = 'supplier:warehouse-inward-order-management:batch-export',
  /** 批量提交 */
  InboundBatchSubmit = 'supplier:warehouse-inward-order-management:batch-submit',
  /** 批量关闭 */
  InboundBatchClose = 'supplier:warehouse-inward-order-management:batch-close',
  /** 新建入库单 */
  InboundAdd = 'supplier:warehouse-inward-order-management:create-inward-orders',
  /** 批量删除 */
  InboundBatchDelete = 'supplier:warehouse-inward-order-management:batch-delete',
  /** 打印 */
  InboundPrint = 'supplier:warehouse-inward-order-management:print',
  /** 批量打印 */
  InboundBatchPrint = 'supplier:warehouse-inward-order-management:batch-print',
  /** 批量修改业务日期 */
  InboundBatchUpdateBusinessDate = 'supplier:inbound:batchUpdateBusinessDate',
  /** 批量修改业务标签 */
  InboundBatchUpdateLabel = 'supplier:inbound:batchUpdateLabel',
  /** <-----------申领单------------> */
  /** 查看申领单 */
  RequisitionView = 'supplier:reconciliation-management:order-apply-view',
  /** 新建申领单 */
  RequisitionNew = 'supplier:reconciliation-management:order-apply-add',
  /** 编辑申领单 */
  RequisitionEdit = 'supplier:reconciliation-management:order-apply-edit',
  /** 提交申领单 */
  RequisitionSubmit = 'supplier:reconciliation-management:order-apply-submit',
  /** 完成申领单 */
  RequisitionComplete = 'supplier:reconciliation-management:order-apply-complete',
  /** 关闭申领单 */
  RequisitionClose = 'supplier:reconciliation-management:order-apply-close',
  /** 删除申领单 */
  RequisitionDelete = 'supplier:reconciliation-management:order-apply-delete',
  /** 批量导出 */
  RequisitionBatchExport = 'supplier:reconciliation-management:order-apply-exportExcel',
  /** 批量提交 */
  RequisitionBatchSubmit = 'supplier:reconciliation-management:order-apply-batchSubmit',
  /** 批量关闭 */
  RequisitionBatchClose = 'supplier:reconciliation-management:order-apply-batchClose',
  /** 批量删除 */
  RequisitionBatchDelete = 'supplier:reconciliation-management:order-apply-batchClose',
  /** 打印 */
  RequisitionPrint = 'supplier:reconciliation-management:order-print',
  /** 批量打印 */
  RequisitionBatchPrint = 'supplier:reconciliation-management:order-batch-print',
  /** <-----------盘点单------------> */
  /** 查看盘点单 */
  InvntoryView = 'supplier:inventory-counting-order:view-counting-orders',
  /** 新建盘点单 */
  InvntoryCreate = 'supplier:inventory-counting-order:create-counting-orders',
  /** 编辑盘点单 */
  InvntoryEdit = 'supplier:inventory-counting-order:edit-counting-orders',
  /** 抄库 */
  InvntoryCopy = 'supplier:inventory-counting-order:copy-inventory',
  /** 盘点 */
  Invntory = 'supplier:inventory-counting-order:conduct-counting',
  /** 完成盘点单 */
  InvntoryFinish = 'supplier:inventory-counting-order:complete-counting-orders',
  /** 过账 */
  InvntoryPosted = 'supplier:inventory-counting-order:post-counting-orders',
  /** 关闭盘点单 */
  InvntoryClose = 'supplier:inventory-counting-order:close-counting-orders',
  /** 删除盘点单 */
  InvntoryDelete = 'supplier:inventory-counting-order:delete-counting-orders',
  /** 导出 */
  InvntoryExport = 'supplier:inventory-counting-order:batch-export',
  /** 批量完成 */
  InvntoryBatchFinish = 'supplier:inventory-counting-order:batch-complete',
  /** 批量关闭 */
  InvntoryBatchClose = 'supplier:inventory-counting-order:batch-close',
  /** 批量删除 */
  InvntoryBatchDelete = 'supplier:inventory-counting-order:batch-delete',
  /** <-----------出库单------------> */
  /** 查看出库单 */
  OutboundView = 'supplier:warehouse-outward-order-management:view-outward-orders',
  /** 编辑出库单 */
  OutboundEdit = 'supplier:warehouse-outward-order-management:edit-outward-orders',
  /** 提交出库单 */
  OutboundSubmit = 'supplier:warehouse-outward-order-management:submit-outward-orders',
  /** 关闭出库单 */
  OutboundClose = 'supplier:warehouse-outward-order-management:close-outward-orders',
  /** 删除出库单 */
  OutboundDelete = 'supplier:warehouse-outward-order-management:delete-outward-orders',
  /** 导出出库单 */
  OutboundExport = 'supplier:warehouse-outward-order-management:batch-export',
  /** 新建出库单 */
  OutboundAdd = 'supplier:warehouse-outward-order-management:create-outward-orders',
  /** 批量提交出库单 */
  OutboundBatchSubmit = 'supplier:warehouse-outward-order-management:batch-submit',
  /** 批量关闭出库单 */
  OutboundBatchClose = 'supplier:warehouse-outward-order-management:batch-close',
  /** 批量删除出库单 */
  OutboundBatchDelete = 'supplier:warehouse-outward-order-management:batch-delete',
  /** 打印出库单 */
  OutboundPrint = 'supplier:warehouse-outward-order-management:print',
  /** 批量打印出库单 */
  OutboundBatchPrint = 'supplier:warehouse-outward-order-management:batch-print',
  /** 批量修改出库单业务日期 */
  OutboundBatchUpdateBusinessDate = 'supplier:outbound:batchUpdateBusinessDate',
  /** 批量修改出库单业务标签 */
  OutboundBatchUpdateLabel = 'supplier:outbound:batchUpdateLabel',
  /** <-----------预警：无质检报告采购单（与常规采购单权限点独立）------------> */
  /** 查看列表/采购单编号 */
  WarningQualityReportMissingList = 'supplier:quality-report-missing:view-purchase-order-list',
  /** 查看采购单 */
  WarningQualityReportMissingView = 'supplier:quality-report-missing:view-purchase-orders',
  /** 编辑采购单 */
  WarningQualityReportMissingEdit = 'supplier:quality-report-missing:edit-purchase-orders',
  /** 查看质检报告 */
  WarningQualityReportMissingInspectionReportView = 'supplier:quality-report-missing:view-quality-inspection-reports',
  /** 查看收货记录 */
  WarningQualityReportMissingReceiptRecordView = 'supplier:quality-report-missing:view-receipt-records',
  /** 备货 */
  WarningQualityReportMissingStockUp = 'supplier:quality-report-missing:prepare-purchase-orders',
  /** 发货 */
  WarningQualityReportMissingDeliverGoods = 'supplier:quality-report-missing:ship-purchase-orders',
  /** 撤回 */
  WarningQualityReportMissingWithdraw = 'supplier:quality-report-missing:recall-purchase-orders',
  /** 打印 */
  WarningQualityReportMissingPrint = 'supplier:quality-report-missing:print-purchase-orders',
  /** 批量打印 */
  WarningQualityReportMissingBatchPrint = 'supplier:quality-report-missing:batch-print',
  /** 批量备货 */
  WarningQualityReportMissingBatchStockUp = 'supplier:quality-report-missing:batch-prepare',
  /** 批量发货 */
  WarningQualityReportMissingBatchDeliverGoods = 'supplier:quality-report-missing:batch-ship',
  /** 批量导出 */
  WarningQualityReportMissingBatchExport = 'supplier:quality-report-missing:batch-export',
  /** 批量改价 */
  WarningQualityReportMissingBatchModifyPrice = 'supplier:quality-report-missing:bulk-repricing',
  /** 维护分拣记录 */
  WarningQualityReportMissingUpdateSortingRecord = 'supplier:quality-report-missing:maintain-sorting-records',

  /** <-----------预警：差评采购单------------> */
  WarningBadReviewsPurchaseList = 'supplier:bad-reviews-purchase:view-purchase-order-list',
  WarningBadReviewsPurchaseView = 'supplier:bad-reviews-purchase:view-purchase-orders',
  WarningBadReviewsPurchaseEdit = 'supplier:bad-reviews-purchase:edit-purchase-orders',
  WarningBadReviewsPurchaseInspectionReportView = 'supplier:bad-reviews-purchase:view-quality-inspection-reports',
  WarningBadReviewsPurchaseReceiptRecordView = 'supplier:bad-reviews-purchase:view-receipt-records',
  WarningBadReviewsPurchaseStockUp = 'supplier:bad-reviews-purchase:prepare-purchase-orders',
  WarningBadReviewsPurchaseDeliverGoods = 'supplier:bad-reviews-purchase:ship-purchase-orders',
  WarningBadReviewsPurchaseWithdraw = 'supplier:bad-reviews-purchase:recall-purchase-orders',
  WarningBadReviewsPurchasePrint = 'supplier:bad-reviews-purchase:print-purchase-orders',
  WarningBadReviewsPurchaseBatchPrint = 'supplier:bad-reviews-purchase:batch-print',
  WarningBadReviewsPurchaseBatchStockUp = 'supplier:bad-reviews-purchase:batch-prepare',
  WarningBadReviewsPurchaseBatchDeliverGoods = 'supplier:bad-reviews-purchase:batch-ship',
  WarningBadReviewsPurchaseBatchExport = 'supplier:bad-reviews-purchase:batch-export',
  WarningBadReviewsPurchaseBatchModifyPrice = 'supplier:bad-reviews-purchase:bulk-repricing',
  WarningBadReviewsPurchaseUpdateSortingRecord = 'supplier:bad-reviews-purchase:maintain-sorting-records',

  /** <-----------预警：逾期送达------------> */
  WarningOverdueDeliveryList = 'supplier:overdue-delivery-purchase:view-purchase-order-list',
  WarningOverdueDeliveryView = 'supplier:overdue-delivery-purchase:view-purchase-orders',
  WarningOverdueDeliveryEdit = 'supplier:overdue-delivery-purchase:edit-purchase-orders',
  WarningOverdueDeliveryInspectionReportView = 'supplier:overdue-delivery-purchase:view-quality-inspection-reports',
  WarningOverdueDeliveryReceiptRecordView = 'supplier:overdue-delivery-purchase:view-receipt-records',
  WarningOverdueDeliveryStockUp = 'supplier:overdue-delivery-purchase:prepare-purchase-orders',
  WarningOverdueDeliveryDeliverGoods = 'supplier:overdue-delivery-purchase:ship-purchase-orders',
  WarningOverdueDeliveryWithdraw = 'supplier:overdue-delivery-purchase:recall-purchase-orders',
  WarningOverdueDeliveryPrint = 'supplier:overdue-delivery-purchase:print-purchase-orders',
  WarningOverdueDeliveryBatchPrint = 'supplier:overdue-delivery-purchase:batch-print',
  WarningOverdueDeliveryBatchStockUp = 'supplier:overdue-delivery-purchase:batch-prepare',
  WarningOverdueDeliveryBatchDeliverGoods = 'supplier:overdue-delivery-purchase:batch-ship',
  WarningOverdueDeliveryBatchExport = 'supplier:overdue-delivery-purchase:batch-export',
  WarningOverdueDeliveryBatchModifyPrice = 'supplier:overdue-delivery-purchase:bulk-repricing',
  WarningOverdueDeliveryUpdateSortingRecord = 'supplier:overdue-delivery-purchase:maintain-sorting-records',

  /** <-----------预警：少送错送------------> */
  WarningLessWrongDeliveryList = 'supplier:less-delivery-purchase:view-purchase-order-list',
  WarningLessWrongDeliveryView = 'supplier:less-delivery-purchase:view-purchase-orders',
  WarningLessWrongDeliveryEdit = 'supplier:less-delivery-purchase:edit-purchase-orders',
  WarningLessWrongDeliveryInspectionReportView = 'supplier:less-delivery-purchase:view-quality-inspection-reports',
  WarningLessWrongDeliveryReceiptRecordView = 'supplier:less-delivery-purchase:view-receipt-records',
  WarningLessWrongDeliveryStockUp = 'supplier:less-delivery-purchase:prepare-purchase-orders',
  WarningLessWrongDeliveryDeliverGoods = 'supplier:less-delivery-purchase:ship-purchase-orders',
  WarningLessWrongDeliveryWithdraw = 'supplier:less-delivery-purchase:recall-purchase-orders',
  WarningLessWrongDeliveryPrint = 'supplier:less-delivery-purchase:print-purchase-orders',
  WarningLessWrongDeliveryBatchPrint = 'supplier:less-delivery-purchase:batch-print',
  WarningLessWrongDeliveryBatchStockUp = 'supplier:less-delivery-purchase:batch-prepare',
  WarningLessWrongDeliveryBatchDeliverGoods = 'supplier:less-delivery-purchase:batch-ship',
  WarningLessWrongDeliveryBatchExport = 'supplier:less-delivery-purchase:batch-export',
  WarningLessWrongDeliveryBatchModifyPrice = 'supplier:less-delivery-purchase:bulk-repricing',
  WarningLessWrongDeliveryUpdateSortingRecord = 'supplier:less-delivery-purchase:maintain-sorting-records',

  /** <-----------预警：包装破损------------> */
  WarningDamagedPackageList = 'supplier:damaged-package-purchase:view-purchase-order-list',
  WarningDamagedPackageView = 'supplier:damaged-package-purchase:view-purchase-orders',
  WarningDamagedPackageEdit = 'supplier:damaged-package-purchase:edit-purchase-orders',
  WarningDamagedPackageInspectionReportView = 'supplier:damaged-package-purchase:view-quality-inspection-reports',
  WarningDamagedPackageReceiptRecordView = 'supplier:damaged-package-purchase:view-receipt-records',
  WarningDamagedPackageStockUp = 'supplier:damaged-package-purchase:prepare-purchase-orders',
  WarningDamagedPackageDeliverGoods = 'supplier:damaged-package-purchase:ship-purchase-orders',
  WarningDamagedPackageWithdraw = 'supplier:damaged-package-purchase:recall-purchase-orders',
  WarningDamagedPackagePrint = 'supplier:damaged-package-purchase:print-purchase-orders',
  WarningDamagedPackageBatchPrint = 'supplier:damaged-package-purchase:batch-print',
  WarningDamagedPackageBatchStockUp = 'supplier:damaged-package-purchase:batch-prepare',
  WarningDamagedPackageBatchDeliverGoods = 'supplier:damaged-package-purchase:batch-ship',
  WarningDamagedPackageBatchExport = 'supplier:damaged-package-purchase:batch-export',
  WarningDamagedPackageBatchModifyPrice = 'supplier:damaged-package-purchase:bulk-repricing',
  WarningDamagedPackageUpdateSortingRecord = 'supplier:damaged-package-purchase:maintain-sorting-records',

  /** <-----------预警：温湿度不达标------------> */
  WarningTemperatureHumidityList = 'supplier:temperature-humidity-purchase:view-purchase-order-list',
  WarningTemperatureHumidityView = 'supplier:temperature-humidity-purchase:view-purchase-orders',
  WarningTemperatureHumidityEdit = 'supplier:temperature-humidity-purchase:edit-purchase-orders',
  WarningTemperatureHumidityInspectionReportView = 'supplier:temperature-humidity-purchase:view-quality-inspection-reports',
  WarningTemperatureHumidityReceiptRecordView = 'supplier:temperature-humidity-purchase:view-receipt-records',
  WarningTemperatureHumidityStockUp = 'supplier:temperature-humidity-purchase:prepare-purchase-orders',
  WarningTemperatureHumidityDeliverGoods = 'supplier:temperature-humidity-purchase:ship-purchase-orders',
  WarningTemperatureHumidityWithdraw = 'supplier:temperature-humidity-purchase:recall-purchase-orders',
  WarningTemperatureHumidityPrint = 'supplier:temperature-humidity-purchase:print-purchase-orders',
  WarningTemperatureHumidityBatchPrint = 'supplier:temperature-humidity-purchase:batch-print',
  WarningTemperatureHumidityBatchStockUp = 'supplier:temperature-humidity-purchase:batch-prepare',
  WarningTemperatureHumidityBatchDeliverGoods = 'supplier:temperature-humidity-purchase:batch-ship',
  WarningTemperatureHumidityBatchExport = 'supplier:temperature-humidity-purchase:batch-export',
  WarningTemperatureHumidityBatchModifyPrice = 'supplier:temperature-humidity-purchase:bulk-repricing',
  WarningTemperatureHumidityUpdateSortingRecord = 'supplier:temperature-humidity-purchase:maintain-sorting-records',

  /** <-----------预警：健康证过期（员工）------------> */
  WarningHealthCertExpiredList = 'supplier:employee-health-cert-expired:view-employee-list',
  WarningHealthCertExpiredView = 'supplier:employee-health-cert-expired:view-employees',
  WarningHealthCertExpiredEdit = 'supplier:employee-health-cert-expired:edit-employees',
  WarningHealthCertExpiredEnable = 'supplier:employee-health-cert-expired:enable-employees',
  WarningHealthCertExpiredDisable = 'supplier:employee-health-cert-expired:disable-employees',
  WarningHealthCertExpiredDelete = 'supplier:employee-health-cert-expired:delete-employees',
  WarningHealthCertExpiredBatchEnable = 'supplier:employee-health-cert-expired:batch-enable',
  WarningHealthCertExpiredBatchDisable = 'supplier:employee-health-cert-expired:batch-disable',
  WarningHealthCertExpiredBatchDelete = 'supplier:employee-health-cert-expired:batch-delete',
  WarningHealthCertExpiredBatchExport = 'supplier:employee-health-cert-expired:export',

  /** <-----------采购需求汇总------------> */
  /** 采购需求汇总列表 */
  ProcurementDemandSummaryList = 'supplier:purchase-demand-summary:view-summary-list',
  /** 采购需求汇总批量导出 */
  ProcurementDemandSummaryBatchExport = 'supplier:purchase-demand-summary:batch-export',
  /** 采购明细 */
  ProcurementDemandSummaryDetail = 'supplier:purchase-demand-summary:detail',
  /** 采购需求汇总打印 */
  ProcurementDemandSummaryPrint = 'supplier:purchase-demand-summary:print',
  /** 采购需求汇总批量打印 */
  ProcurementDemandSummaryBatchPrint = 'supplier:purchase-demand-summary:batch-print',
  /** <-----------支付流水------------> */
  /** 付款单查看 */
  PaymentOrderView = 'supplier:payment-flow:view-payment-orders',
  /** 付款单核销 */
  PaymentOrderWriteOff = 'supplier:payment-flow:write-off-payment-orders',
  /** 付款单批量核销 */
  PaymentOrderBatchWriteOff = 'supplier:payment-flow:batch-write-off',
  /** 付款单批量导出 */
  PaymentOrderBatchExport = 'supplier:payment-flow:batch-export',
  /** 付款单审核 */
  PaymentOrderAudit = 'supplier:payment-flow:audit',
  /** <-----------对账单------------> */
  /** 对账单查看 */
  ReconciliationOrderView = 'supplier:reconciliation-management:view-reconciliation-statements',
  /** 对账单确认 */
  ReconciliationOrderConfirm = 'supplier:reconciliation-management:confirm-reconciliation-statements',
  /** 对账单批量确认 */
  ReconciliationOrderBatchConfirm = 'supplier:reconciliation-management:batch-confirm',
  /** 对账单批量导出 */
  ReconciliationOrderBatchExport = 'supplier:reconciliation-management:batch-export',
  /** 对账单查看回单记录 */
  SupplierReconciliationReceiptPage = 'supplier:reconciliation-receipt:page',
  /** <-----------应收汇总------------> */
  /** 应收汇总批量导出 */
  AccountsReceivableSummaryBatchExport = 'supplier:receivable-summary:batch-export',
  /** -----------------开票记录------------------- */
  /** 新建开票记录 */
  BillRecordNew = 'supplier:invoice-record:add',
  /** 编辑开票记录 */
  BillRecordEdit = 'supplier:invoice-record:editing',
  /** 提交开票记录 */
  BillRecordSubmit = 'supplier:invoice-record:submit',
  /** 作废开票记录 */
  BillRecordCancel = 'supplier:invoice-record:nullify',
  /** 删除开票记录 */
  BillRecordDelete = 'supplier:invoice-record:delete',
  /** 批量作废 */
  BillRecordBatchCancel = 'supplier:invoice-record:batch-nullify',
  /** 批量删除 */
  BillRecordBatchDelete = 'supplier:invoice-record:batch-delete',
  /** 批量导出 */
  BillRecordBatchExport = 'supplier:invoice-record:excel',
  /** 查看开票记录 */
  BillRecordView = 'supplier:invoice-record:get-info',
  /** <-----------采购汇总------------> */
  /** 采购汇总批量导出 */
  ProcurementSummaryBatchExport = 'supplier:purchase-summary-table:batch-export',
  /** <-----------用户管理------------> */
  /** 用户新建 */
  UserNew = 'supplier:user-management:create-users',
  /** 用户编辑 */
  UserEdit = 'supplier:user-management:edit-users',
  /** 用户修改密码 */
  UserEditPassword = 'supplier:user-management:change-passwords',
  /** 用户启用 */
  UserEnable = 'supplier:user-management:enable-users',
  /** 用户禁用 */
  UserDisable = 'supplier:user-management:disable-users',
  /** 用户删除 */
  UserDelete = 'supplier:user-management:delete-users',
  /** 用户批量启用 */
  UserBatchEnable = 'supplier:user-management:batch-enable',
  /** 用户批量禁用 */
  UserBatchDisable = 'supplier:user-management:batch-disable',
  /** 用户批量删除 */
  UserBatchDelete = 'supplier:user-management:batch-delete',
  /** 数据权限 */
  DataPermission = 'supplier:user-management:permission',
  /** <-----------角色管理------------> */
  /** 角色新建 */
  RoleNew = 'supplier:role-management:create-roles',
  /** 角色编辑 */
  RoleEdit = 'supplier:role-management:edit-roles',
  /** 角色删除 */
  RoleDelete = 'supplier:role-management:delete-roles',

  /**  ================================ '员工管理 ================================ '*/
  /** 查看员工 */
  EmployeeView = 'supplier:employee-management:view-employees',
  /** 新建员工 */
  EmployeeNew = 'supplier:employee-management:create-employees',
  /** 编辑员工 */
  EmployeeEdit = 'supplier:employee-management:edit-employees',
  /** 启用员工 */
  EmployeeEnable = 'supplier:employee-management:enable-employees',
  /** 禁用员工 */
  EmployeeDisable = 'supplier:employee-management:disable-employees',
  /** 删除员工 */
  EmployeeDelete = 'supplier:employee-management:delete-employees',
  /** 批量启用 */
  EmployeeBatchEnable = 'supplier:employee-management:batch-enable',
  /** 批量禁用 */
  EmployeeBatchDisable = 'supplier:employee-management:batch-disable',
  /** 批量删除 */
  EmployeeBatchDelete = 'supplier:employee-management:batch-delete',
  /** 批量导入 */
  EmployeeBatchImport = 'supplier:employee-management:import',
  /** 批量导出 */
  EmployeeBatchExport = 'supplier:employee-management:export',
  /**  ================================ 配送任务 ================================ '*/
  /** 查看配送任务 */
  DeliveryTaskView = 'supplier:delivery-management:task-detail',
  /** 一键排线 */
  QuickWiring = 'supplier:delivery-management:task-add-plan',
  /** 新增配送任务 */
  DeliveryTaskAdd = 'supplier:delivery-management:task-add',
  /** 编辑配送任务 */
  DeliveryTaskEdit = 'supplier:delivery-management:task-update',
  /** 完成配送任务 */
  DeliveryTaskFinish = 'supplier:delivery-management:task-finish',
  /** 关闭配送任务 */
  DeliveryTaskClose = 'supplier:delivery-management:task-close',
  /** 删除配送任务 */
  DeliveryTaskDelete = 'supplier:delivery-management:task-delete',
  /** 批量删除 */
  DeliveryTaskBatchDelete = 'supplier:delivery-management:task-batch-delete',
  /** 批量关闭 */
  DeliveryTaskBatchClose = 'supplier:delivery-management:task-batch-close',
  /** 批量完成 */
  DeliveryTaskBatchFinish = 'supplier:delivery-management:task-batch-finish',
  /** 批量打印 */
  DeliveryTaskBatchPrint = 'supplier:delivery-management:task-print',
  /**  ================================ 配送路线 ================================ '*/
  /** 查看配送路线 */
  DeliveryLineView = 'supplier:delivery-management:line-detail',
  /** 新增配送路线 */
  DeliveryLineAdd = 'supplier:delivery-management:line-add',
  /** 编辑配送路线 */
  DeliveryLineEdit = 'supplier:delivery-management:line-update',
  /** 删除配送路线 */
  DeliveryLineDelete = 'supplier:delivery-management:line-delete',
  /** 批量删除配送路线 */
  DeliveryLineBatchDelete = 'supplier:delivery-management:line-batch-delete',
  /**  ================================ 司机管理 ================================ '*/
  /** 新增司机 */
  DriverAdd = 'supplier:delivery-management:diver-add',
  /** 编辑司机 */
  DriverEdit = 'supplier:delivery-management:diver-update',
  /** 删除司机 */
  DriverDelete = 'supplier:delivery-management:diver-delete',
  /** 批量删除司机 */
  DriverBatchDelete = 'supplier:delivery-management:diver-batch-delete',
  /**  ================================ 车辆 ================================ '*/
  /** 查看车辆列表 */
  CarView = 'supplier:car-list',
  /** 新建车辆 */
  CarCreate = 'supplier:car-add',
  /** 编辑车辆 */
  CarEdit = 'supplier:car-update',
  /** 删除车辆 */
  CarDelete = 'supplier:car-delete',
  /** 批量删除 */
  CarBatchDelete = 'supplier:car-batch-delete',
  /**  ================================ 收支项目管理 ================================ */
  /** 查看收支项目 */
  IncomeExpenseProjectView = 'supplier:revenue-record:detail',
  /** 新建收支项目 */
  IncomeExpenseProjectNew = 'supplier:revenue-record:save',
  /** 编辑收支项目 */
  IncomeExpenseProjectEdit = 'supplier:revenue-record:detail:update',
  /** 删除收支项目 */
  IncomeExpenseProjectDelete = 'supplier:revenue-record:delete',
  /** 收支项目管理 */
  IncomeExpenseProjectManage = 'supplier:revenue-record:manage:list',
  /** 批量删除收支项目 */
  IncomeExpenseProjectBatchDelete = 'supplier:revenue-record:batchDelete',
  /** 批量导出收支项目 */
  IncomeExpenseProjectBatchExport = 'supplier:revenue-record:exportExcel:record',
  /**  ================================ 财务汇总表 ================================ */
  /** 批量导出 */
  FinancialSummaryBatchExport = 'supplier:revenue:statistics-export',
  /**  ================================ 周转筐记录 ================================ */
  /** 查看周转筐记录 */
  TurnoverBasketRecordView = 'supply:turnover-basket:detail',
  /** 新增周转筐记录 */
  TurnoverBasketRecordAdd = 'supply:turnover-basket:add',
  /** 编辑周转筐记录 */
  TurnoverBasketRecordEdit = 'supply:turnover-basket:update',
  /** 提交周转筐记录 */
  TurnoverBasketRecordSubmit = 'supply:turnover-basket:finish',
  /** 关闭周转筐记录 */
  TurnoverBasketRecordClose = 'supply:turnover-basket:close',
  /** 删除周转筐记录 */
  TurnoverBasketRecordDelete = 'supply:turnover-basket:delete',
  /** 周转筐管理 */
  TurnoverBasketManage = 'supply:turnover-basket:manage',
  /** 批量删除周转筐记录 */
  TurnoverBasketRecordBatchDelete = 'supply:turnover-basket:batch-delete',
  /** 批量关闭周转筐记录 */
  TurnoverBasketRecordBatchClose = 'supply:turnover-basket:batch-close',
  /**  ================================ 周转筐统计 ================================ */
  /** 周转筐统计批量导出 */
  TurnoverBasketStatisticsBatchExport = 'supply:turnover-basket:statistic',
  /**  ================================ 套餐管理 ================================ */
  /** 套餐列表 */
  PackageManageList = 'supervisor:supplier-performance:menu-fixed:list',
  /** 查看套餐 */
  PackageManageView = 'supervisor:supplier-performance:menu-fixed:view',
  /** 新建套餐 */
  PackageManageNew = 'supervisor:supplier-performance:menu-fixed:add',
  /** 编辑套餐 */
  PackageManageEdit = 'supervisor:supplier-performance:menu-fixed:edit',
  /** 删除套餐 */
  PackageManageDelete = 'supervisor:supplier-performance:menu-fixed:deleted',
  /** 批量导出套餐 */
  PackageManageBatchExport = 'supervisor:supplier-performance:menu-fixed:export',
  /** 批量删除套餐 */
  PackageManageBatchDelete = 'supervisor:supplier-performance:menu-fixed:batch-deleted',
  /**  ================================ 报餐记录 ================================ */
  /** 报餐列表 */
  MealRecordList = 'supervisor:supplier-performance:menu-record:list',
  /** 查看报餐记录 */
  MealRecordView = 'supervisor:supplier-performance:menu-record:view',
  /** 批量导出 */
  MealRecordBatchExport = 'supervisor:supplier-performance:menu-record:export',
  /**  ================================ 套餐需求汇总 ================================ */
  /** 套餐需求汇总列表 */
  PackageDemandSummaryList = 'supervisor:supplier-performance:menu-record-summary:list',
  /** 套餐需求汇总导出 */
  PackageDemandSummaryExport = 'supervisor:supplier-performance:menu-record-summary:export',
  /**  ================================ 商品税率 ================================ */
  /** 商品税率列表 */
  TaxRateList = 'supervisor:tax_rate:list',
  /** 商品税率设置 */
  TaxRateSet = 'supervisor:tax_rate:set-tax',
  /** 商品税率批量设置 */
  TaxRateBatchSet = 'supervisor:tax_rate:batch-set-tax',
  /** 商品税率批量导出 */
  TaxRateBatchExport = 'supervisor:tax_rate:export',
  /** 商品税率批量导入 */
  TaxRateBatchImport = 'supervisor:tax_rate:import',
  /**  ================================ 滞销品 ================================ */
  /** 滞销品列表 */
  DeadStockList = 'supplier:unsoldProduct:query-list',
  /** 滞销品规则设置 */
  DeadStockRuleSet = 'supplier:unsoldProduct:update-category-unsold-days',
  /** 批量导出 */
  DeadStockBatchExport = 'supplier:unsoldProduct:export-unsold-product',
  /**  ================================ 项目 ================================ */
  /** 项目列表 */
  ProjectList = 'supplier:project:list',
  /** 投标 */
  ProjectBid = 'supplier:project:create-pact',
  /** 查看报价 */
  ProjectViewQuotation = 'supplier:project:quotation-view',
  /** 查看合同 */
  ProjectViewPact = 'supplier:project:pact-view',
  /**  ================================ 售后单 ================================ */
  /** 售后单查看列表 */
  AfterSalesList = 'supervisor:after-sale:list',
  /** 售后单查看明细 */
  AfterSalesDetail = 'supervisor:after-sale:page',
  /** 售后单确认 */
  AfterSalesConfirm = 'supervisor:after-sale:confirm',
  /** 售后单撤回 */
  AfterSalesRevoke = 'supervisor:after-sale:revoke',
  /** 售后单退货验收 */
  AfterSalesAcceptance = 'supervisor:after-sale:acceptance',
  /** 查看退货记录 */
  AfterSalesReturn = 'supervisor:after-sale:retrun-record',
  /** 查看验收记录 */
  AfterSalesCheck = 'supervisor:after-sale:update-acceptance-record',
  /** 售后单批量导出 */
  AfterSalesBatchExport = 'supervisor:after-sale:batch-export',
  /** 售后单批量确认 */
  AfterSalesBatchConfirm = 'supervisor:after-sale:batch-chonfirm',
  /** 售后单批量退货验收 */
  AfterSalesBatchAcceptance = 'supervisor:after-sale:batch-acceptance',
  /** 售后单打印 */
  AfterSalesPrint = 'supervisor:after-sale:print',
  /** 售后单批量打印 */
  AfterSalesBatchPrint = 'supervisor:after-sale:batch-print',

  /**  ================================ 商品行情价 ================================ */
  /** 商品行情价查看列表 */
  MarketPriceList = 'supplier:market-price:list',
  /** 商品行情价查看明细 */
  MarketPriceDetail = 'supplier:market-price:get-info',
  /**  ================================ 折扣定价 ================================ */
  /** 折扣定价查看列表 */
  DiscountPriceList = 'supplier:discounted-pricing:list',
  /** 折扣定价查看明细 */
  DiscountPriceDetail = 'supplier:discounted-pricing:get-info',
  /** 折扣定价报价 */
  DiscountPriceQuotation = 'supplier:discounted-pricing:quotation',
  /** 折扣定价查看报价 */
  DiscountPriceQuotationDetail = 'supplier:discounted-pricing:get-quotation-info',
  /**  ================================ 采购商品备注 ================================ */
  /** 采购商品备注列表 */
  PurchaseSkuRemarkList = 'supervisor:product-remark:list',
  /** 采购商品备注导出 */
  PurchaseSkuRemarkExport = 'supervisor:product-remark:batch-export',
  /**  ================================ 司机绩效 ================================ */
  /** 司机绩效列表 */
  DriverPerformanceList = 'supervisor:delivery-performance:list',
  /** 司机绩效导出 */
  DriverPerformanceExport = 'supervisor:delivery-performance:batch-export',
  /**  ================================ 行车报警 ================================ */
  /** 行车报警导出 */
  VehicleAlarmExport = 'supplier:b-vehicle:alarm:export',
  /** 行车报警列表 */
  VehicleAlarmList = 'supplier:b-vehicle:alarm:list',
  /**  ================================ 采购明细表 ================================ */
  /** 采购明细表 */
  PurchaseDetailList = 'supplier:purchase-summary:list',
  /** 批量导出 */
  PurchaseDetailBatchExport = 'supplier:purchase-summary:export',

  /**  ================================ 利润核算 ================================ */
  /** 利润核算列表 */
  ProfitCalculationList = 'supplier:profitCalculation:list',
  /** 利润核算导出 */
  ProfitCalculationExport = 'supplier:profitCalculation:export',
  /**  ================================ 现场监控违规记录 ================================ */
  /** 违规记录列表 */
  ViolationRecordList = 'supervisor:violation-record:supplier-list',
  /** 违规记录删除 */
  ViolationRecordDelete = 'supervisor:violation-record:supplier-delete',
  /** 违规记录批量删除 */
  ViolationRecordBatchDelete = 'supervisor:violation-record:supplier-batch-delete',
  /**  ================================ 执行记录台账 ================================ */
  /** 执行记录台账列表  */
  ExecutionRecordLedgerList = 'supplier:executionRecordLedger:queryList',
  /** 执行记录台账详情 */
  ExecutionRecordLedgerDetail = 'supplier:executionRecordLedger:getInfo',
  /** 执行记录台账创建 */
  ExecutionRecordLedgerCreate = 'supplier:executionRecordLedger:add',
  /** 执行记录台账删除 */
  ExecutionRecordLedgerDelete = 'supplier:executionRecordLedger:delete',
  /** 执行记录台账重命名 */
  ExecutionRecordLedgerEdit = 'supplier:executionRecordLedger:editor',
  /** 执行记录台账批量删除 */
  ExecutionRecordLedgerBatchDelete = 'supplier:executionRecordLedger:batchDelete',
  /**  ================================ 整改记录 ================================ */
  /** 整改记录列表 */
  RectificationRecordList = 'supplier:inspection:history:list',
  /** 批量导出 */
  RectificationRecordBatchExport = 'supplier:inspection:history:export',
  /**  ================================ 采购评价表 ================================ */
  /** 采购评价列表 */
  PurchaseEvaluateList = 'supervisor:purchase-summar-eval:list',
  /** 批量导出 */
  PurchaseEvaluateBatchExport = 'supervisor:purchase-summar-eval:batch-export',
  /**  ================================ 售后明细表 ================================ */
  /** 明细列表 */
  AfterSaleDetailList = 'supervisor:after-sale-detail-summary:list',
  /** 批量导出 */
  AfterSaleDetailBatchExport = 'supervisor:after-sale-detail-summary:batch-export',
  /**  ================================ 质检报告（批次） ================================ */
  /** 质检报告（批次）列表 */
  QualityInspectionBatchReportList = 'supplier:batch-report:list',
  /** 质检报告（批次）详情 */
  QualityInspectionBatchReportDetail = 'supplier:batch-report:info',
  /** 质检报告（批次）新增 */
  QualityInspectionBatchReportCreate = 'supplier:batch-report:add',
  /** 质检报告（批次）编辑 */
  QualityInspectionBatchReportEdit = 'supplier:batch-report:update',
  /** 质检报告（批次）删除 */
  QualityInspectionBatchReportDelete = 'supplier:batch-report:delete',
  /** 质检报告合并规则设置 */
  QualityInspectionBatchReportMergeRules = 'supplier:batch-report:merge-rules-update',
  /**  ================================ 新品提报 ================================ */
  /** 新品提报列表 */
  NewSubmissionList = 'supplier:product-report:page',
  /** 新建新品提报 */
  NewSubmissionCreate = 'supplier:product-report:add',
  /** 编辑新品提报 */
  NewSubmissionEdit = 'supplier:product-report:update',
  /** 删除新品提报 */
  NewSubmissionDelete = 'supplier:product-report:delete',
  /**  ================================ 对账明细表 ================================ */
  /** 对账明细表列表 */
  StatementDetailList = 'supplier:statement-details-statistics:list',
  /** 对账明细表导出 */
  StatementDetailExport = 'supplier:statement-details-statistics:export',
  /**  ================================ 成本记录 ================================ */
  /** 成本记录列表 */
  CostRecordList = 'supplier:costRecording:list',
  /** 成本记录新建/编辑 */
  CostRecordUpdate = 'supplier:costRecording:addAndUpdate',
  /** 成本记录清空 */
  CostRecordClear = 'supplier:costRecording:clear',
  /** 成本记录批量编辑 */
  CostRecordBatchUpdate = 'supplier:costRecording:batchUpdate',
  /** 成本记录批量更新核算数量 */
  CostRecordBatchUpdateQuantity = 'supplier:costRecording:calculateQuantity',
  /** 成本记录批量清空 */
  CostRecordBatchClear = 'supplier:costRecording:batchClear',
  /** 成本记录批量导出 */
  CostRecordBatchExport = 'supplier:costRecording:batchExport',
  /**  ================================ 委外任务 ================================ */
  /** 委外任务列表 */
  OutsourceTaskList = 'supplier:outsourcedTasks:list',
  /** 委外任务导出 */
  OutsourceTaskExport = 'supplier:outsourcedTasks:export',
  /**  ================================ 委外收入 ================================ */
  /** 委外收入列表 */
  OutsourceIncomeList = 'supplier:outsourcedIncome:queryList',
  /** 委外收入导出 */
  OutsourceIncomeExport = 'supplier:outsourcedIncome:batchExport',
  /**  ================================ 代分拣 ================================ */
  /** 代分拣导出 */
  PurchaseHelpSortingBatchExport = 'supplier:purchaseHelpSorting:batchExport',
  /** 代分拣分拣记录 */
  PurchaseHelpSortingUpdate = 'supplier:purchaseHelpSorting:update',
  /**  ================================ 采购进度 ================================ */
  /** 采购进度列表 */
  PurchaseProgressList = 'supervisor:purchase-process:list',
  /**  ================================ IO记录 ================================ */
  /** IO记录列表 */
  IoRecordList = 'supplier:b-vehicle:list',
  /** IO记录导出 */
  IoRecordExport = 'supplier:b-vehicle:export',
  /**  ================================ 食安考培 ================================ */
  /** 课程试卷列表 */
  CourseExamPaperList = 'supplier:course-examPaper:list',
  /** 课程试卷详情 */
  CourseExamPaperDetail = 'supplier:course:info',
  /** 答题 */
  CourseExamPaperAnswer = 'supplier:course:answering-questions',
  /** 查看答卷 */
  CourseExamPaperView = 'supplier:course:answerInfo',
  /**  ================================ 回单记录 ================================ */
  /** 回单记录列表 */
  ReturnReceiptRecordList = 'supervisor:receipt-record:list',
  /** 回单记录查看 */
  ReturnReceiptRecordView = 'supervisor:receipt-record:page',
  /** 回单记录新建 */
  ReturnReceiptRecordCreate = 'supervisor:receipt-record:add',
  /** 回单记录编辑 */
  ReturnReceiptRecordEdit = 'supervisor:receipt-record:update',
  /** 回单记录删除 */
  ReturnReceiptRecordDelete = 'supervisor:receipt-record:delete',
  /** 回单记录批量删除 */
  ReturnReceiptRecordBatchDelete = 'supervisor:receipt-record:batch-delete',
  /**  ================================ 收据 ================================ */
  /** 收据列表 */
  ReceiptList = 'supplier:platformReceipt:list',
  /** 查看收据 */
  ReceiptView = 'supplier:platformReceipt:info',
  /** 导出收据 */
  ReceiptExport = 'supplier:platformReceipt:export',
  /**  ================================ 工单管理 ================================ */
  /** 查看工单 */
  WorkOrderView = 'supply:workOrder:page',
  /** 新建工单 */
  WorkOrderAdd = 'supply:workOrder:add',
  /** 编辑工单 */
  WorkOrderEdit = 'supply:workOrder:update',
  /** 删除工单 */
  WorkOrderDelete = 'supply:workOrder:delete',
  /** 批量删除工单 */
  WorkOrderBatchDelete = 'supply:workOrder:batchDelete',
  /**  ================================ 仓库管理 ================================ */
  /** 仓库管理列表 */
  WarehouseList = 'supplier:warehouse:stock:list',
  /** 新建仓库 */
  WarehouseCreate = 'supplier:warehouse:stock:add',
  /** 编辑仓库 */
  WarehouseEdit = 'supplier:warehouse:stock:edit',
  /** 启用仓库 */
  WarehouseEnable = 'supplier:warehouse:stock:enable',
  /** 禁用仓库 */
  WarehouseDisable = 'supplier:warehouse:stock:disenable',
  /** 删除仓库 */
  WarehouseDelete = 'supplier:warehouse:stock:deleted',
  /** 批量启用仓库 */
  WarehouseBatchEnable = 'supplier:warehouse:stock:batch-enable',
  /** 批量禁用仓库 */
  WarehouseBatchDisable = 'supplier:warehouse:stock:batch-disenable',
  /** 批量删除仓库 */
  WarehouseBatchDelete = 'supplier:warehouse:stock:batch-deleted',

  /**  ================================ 物料转换 ================================ */
  /** 物料转换查看 */
  MaterialConversionView = 'supplier:material-conversion:view-conversion',
  /** 物料转换批量转换 */
  MaterialConversionBacthChange = 'supplier:material-conversion:batch-conversion',
  /** 物料转换新建 */
  MaterialConversionCreate = 'supplier:material-conversion:create-conversion-order',
  /** 物料转换编辑 */
  MaterialConversionEdit = 'supplier:material-conversion:edit-conversion-order',
  /** 物料转换完成 */
  MaterialConversionFinish = 'supplier:material-conversion:complete-conversion-order',
  /** 物料转换关闭 */
  MaterialConversionClose = 'supplier:material-conversion:close-conversion-order',
  /** 物料转换删除 */
  MaterialConversionDelete = 'supplier:material-conversion:delete-conversion-order',
  /** 物料转换导出 */
  MaterialConversionExport = 'supplier:material-conversion:batch-export',
  /** 物料转换批量完成 */
  MaterialConversionBatchFinish = 'supplier:material-conversion:batch-complete',
  /** 物料转换批量关闭 */
  MaterialConversionBatchClose = 'supplier:material-conversion:batch-close',
  /** 物料转换批量删除 */
  MaterialConversionBatchDelete = 'supplier:material-conversion:batch-delete',
  /**  ================================ 库存台账 ================================ */
  /** 库存台账导出 */
  InventoryLedgerExport = 'supplier:inventory-ledger:batch-export',
  /**  ================================ 实时库存 ================================ */
  /** 批量导出 */
  RealInventoryExport = 'supplier:real-time-inventory:batch-export',
  /**  ================================ 库存明细表 ================================ */
  /** 库存明细表列表 */
  StockDetailList = 'supplier:purchase-register:list',
  /** 库存明细表批量导出 */
  StockDetailBatchExport = 'supplier:purchase-register:export',
  /**  ================================ 货源管理 ================================ */
  /** 货源列表 */
  SourceManageList = 'supplier:supplySource:queryList',
  /** 货源查看 */
  SourceManageView = 'supplier:supplySource:info',
  /** 货源新建 */
  SourceManageCreate = 'supplier:supplySource:add',
  /** 货源编辑 */
  SourceManageEdit = 'supplier:supplySource:update',
  /** 货源启用 */
  SourceManageEnable = 'supplier:supplySource:enable',
  /** 货源禁用 */
  SourceManageDisable = 'supplier:supplySource:disable',
  /** 货源删除 */
  SourceManageDelete = 'supplier:supplySource:delete',
  /** 货源导入 */
  SourceManageImport = 'supplier:supplySource:importExcel',
  /** 货源导出 */
  SourceManageExport = 'supplier:supplySource:batchExport',
  /** 批量启用货源 */
  SourceManageBatchEnable = 'supplier:supplySource:batchEnable',
  /** 批量禁用货源 */
  SourceManageBatchDisable = 'supplier:supplySource:batchDisable',
  /** 批量删除货源 */
  SourceManageBatchDelete = 'supplier:supplySource:batchDelete',
  /**  ================================ 补货单 ================================ */
  /** 补货单列表 */
  ReplenishmentOrderList = 'supplier:replenishment:queryList',
  /** 补货单查看 */
  ReplenishmentOrderView = 'supplier:replenishment:info',
  /** 补货单新建 */
  ReplenishmentOrderCreate = 'supplier:replenishment:add',
  /** 补货单编辑 */
  ReplenishmentOrderEdit = 'supplier:replenishment:update',
  /** 补货单完成 */
  ReplenishmentOrderComplete = 'supplier:replenishment:complete',
  /** 补货单关闭 */
  ReplenishmentOrderClose = 'supplier:replenishment:close',
  /** 补货单删除 */
  ReplenishmentOrderDelete = 'supplier:replenishment:delete',
  /** 补货单导出 */
  ReplenishmentOrderExport = 'supplier:replenishment:batchExport',
  /** 批量关闭补货单 */
  ReplenishmentOrderBatchClose = 'supplier:replenishment:batchClose',
  /** 批量删除补货单 */
  ReplenishmentOrderBatchDelete = 'supplier:replenishment:batchDelete',
  /**  ================================ 补货规则 ================================ '*/
  /** 查看列表 */
  ReplenishRulesList = 'supplier:stockSupplement:list',
  /** 新增补货规则 */
  ReplenishRulesCreate = 'supplier:stockSupplement:save',
  /** 编辑补货规则 */
  ReplenishRulesEdit = 'supplier:stockSupplement:update',
  /** 删除补货规则 */
  ReplenishRulesDelete = 'supplier:stockSupplement:delete',
  /** 批量导入 */
  ReplenishRulesBatchImport = 'supplier:stockSupplement:importExcel',
  /** 批量导出 */
  ReplenishRulesExport = 'supplier:stockSupplement:batchExport',
  /** 批量删除 */
  ReplenishRulesBatchDelete = 'supplier:stockSupplement:batchDelete',
}
